import {ReportData} from "../../../reports/report.data";
import {collection} from "@fedeltapointofsale/data-client";
import {InventoryReportSelectionData} from "../../inventory/controls/inventory-report-selection-control.component";


export class StockBatchValuationReportData extends ReportData<StockBatchValuationReportData> {
    @collection() groupBy: string[] = ["none"];

    @collection(InventoryReportSelectionData) inventories: InventoryReportSelectionData[];
}
